// extracted by mini-css-extract-plugin
export default {"bellAnimation":"CampaignsTable_bellAnimation__uVPWV","ring":"CampaignsTable_ring__IqEPl"};